import { MeasureSeriesSortingType } from "../../types";
import { validateArguments } from "../../visitor";
import { dropPartialItem as dropPartialItemFunc } from "./dropPartialItem";
import { filterByDatapoint as filterByDatapointFunc } from "./filterByDatapoint";
import { filterByMostRecentDate as filterByMostRecentDateFunc } from "./filterByMostRecentDate";
import { mapRepRiskRatingToItsNumber as mapRepRiskRatingToItsNumberFunc } from "./mapRepRiskRatingToItsNumber";
import { sortByDatapoint as sortByDatapointFunc } from "./sortByDatapoint";
import { sortByExplicitOrder as sortByExplicitOrderFunc } from "./sortByExplicitOrder";
const sortDatapointsVisitor = (sortFuncValue) => (args) => {
    if (args.visitable?.length < 1) {
        return;
    }
    args.visitable = [...args.visitable].sort((a, b) => sortFuncValue(args, a, b));
};
const filterDatapointsVisitor = (filterFuncValue) => (args) => {
    if (args.visitable?.length < 1) {
        return;
    }
    args.visitable = args.visitable.filter((d) => filterFuncValue(args, d));
};
const mapDatapointsVisitor = (mapFuncValue) => (args) => {
    if (args.visitable?.length < 1) {
        return;
    }
    args.visitable = args.visitable.map((d) => mapFuncValue(args, d));
};
// For our current use-case there is no overlapping between datapoints so order of who overides who is not important, you'll need to add some argument if order is important to you
const mergeByYearVisitor = () => (args) => {
    if (args.visitable?.length < 1) {
        return;
    }
    const newVisitable = [];
    args.visitable.forEach((value) => {
        const index = newVisitable.findIndex((x) => x.date?.getFullYear() === value.date?.getFullYear());
        if (index === -1) {
            newVisitable.push({ datapoints: value.datapoints, date: value.date });
        }
        else {
            newVisitable[index].datapoints = [...newVisitable[index].datapoints ?? [], ...value.datapoints ?? []];
        }
    });
    args.visitable = newVisitable;
};
export var DatapointsVisitorEnum;
(function (DatapointsVisitorEnum) {
    DatapointsVisitorEnum["filterByDatapoint"] = "filterByDatapoint";
    DatapointsVisitorEnum["filterByMostRecentDate"] = "filterByMostRecentDate";
    DatapointsVisitorEnum["mapRepRiskRatingToItsNumber"] = "mapRepRiskRatingToItsNumber";
    DatapointsVisitorEnum["sortByDatapoint"] = "sortByDatapoint";
    DatapointsVisitorEnum["sortByExplicitOrder"] = "sortByExplicitOrder";
    DatapointsVisitorEnum["dropPartialItem"] = "dropPartialItem";
    DatapointsVisitorEnum["mergeByYear"] = "mergeByYear";
})(DatapointsVisitorEnum || (DatapointsVisitorEnum = {}));
export const DatapointsVisitors = {
    [DatapointsVisitorEnum.filterByDatapoint]: {
        composeBackward: false,
        visitor: (args) => {
            validateArguments(filterByDatapointFunc.name, 3, args);
            return filterDatapointsVisitor(filterByDatapointFunc(args[0], args[1], args[2]));
        }
    },
    [DatapointsVisitorEnum.filterByMostRecentDate]: {
        composeBackward: false,
        visitor: () => filterDatapointsVisitor(filterByMostRecentDateFunc())
    },
    [DatapointsVisitorEnum.mapRepRiskRatingToItsNumber]: {
        composeBackward: false,
        visitor: (args) => {
            validateArguments(mapRepRiskRatingToItsNumberFunc.name, 1, args);
            return mapDatapointsVisitor(mapRepRiskRatingToItsNumberFunc(args[0]));
        }
    },
    [DatapointsVisitorEnum.sortByDatapoint]: {
        composeBackward: true,
        visitor: (args) => {
            if (validateArguments(sortByDatapointFunc.name, 2, args)) {
                if (!(args[1] in MeasureSeriesSortingType)) {
                    throw new Error(`sortByDatapoint should have its second arguments as a MeasureSeriesSortingType. Found ${args[1]?.toString()}`);
                }
            }
            return sortDatapointsVisitor(sortByDatapointFunc(args[0], args[1]));
        }
    },
    [DatapointsVisitorEnum.sortByExplicitOrder]: {
        composeBackward: true,
        visitor: (args) => {
            validateArguments(sortByExplicitOrderFunc.name, 2, args);
            return sortDatapointsVisitor(sortByExplicitOrderFunc(args[0], args[1]));
        }
    },
    [DatapointsVisitorEnum.dropPartialItem]: {
        composeBackward: false,
        visitor: (args, config) => filterDatapointsVisitor(dropPartialItemFunc((config?.dimensions?.length || 1) + (config?.measures.length || 0)))
    },
    [DatapointsVisitorEnum.mergeByYear]: {
        composeBackward: true,
        visitor: () => mergeByYearVisitor()
    }
};
